import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import useSessionTimeRangeService from '../../api/services/SessionTimeRangeService';
import BaseDialog from '../../components/BaseDialog';
import { toast } from 'react-hot-toast';

function DeleteDialog({ open, onClose, sessionTimeRangeId, currentStatus, onSuccess }) {
    const { updateSessionTimeRangeStatus } = useSessionTimeRangeService();

    const handleChangeStatus = async () => {
        try {
            await updateSessionTimeRangeStatus(sessionTimeRangeId, currentStatus, () => {
                onSuccess?.();
                onClose();
            });
            toast.success('Session time range status updated successfully!');
        } catch (error) {
            console.error('Delete failed:', error);
            toast.error(error.response?.data?.message || 'Failed to update session time range status');
        }
    };

    return (
        <BaseDialog
            open={open}
            onClose={onClose}
            title={`Do you want to ${currentStatus === 'ACTIVE' ? 'DEACTIVATE' : 'ACTIVATE'} the specified session time range?`}
            confirmButtonText={currentStatus === 'ACTIVE' ? 'DEACTIVATE' : 'ACTIVATE'}
            cancelButtonText="Cancel"
            onConfirm={handleChangeStatus}
            confirmButtonColor="error"
            cancelButtonColor="secondary"
        />
    );
}

export default DeleteDialog;

